import type {
  ITableReport,
  Report,
} from "../Interfaces/TableInterfaces";

export const removeCanTradeManagementColumn = <T extends ITableReport>(
  report: Report<T>
): Report<T> => ({
  ...report,
  translatedHeaders: report.translatedHeaders.filter(
    (header) =>
      header.headerName.trim().toLowerCase() !== "cantrade" &&
      header.translateHeaderName.trim().toLowerCase() !== "cantrade"
  ),
});
